import { Component, Input } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { PropertyInquiryContactFormComponent } from './property-inquiry-contact-form'
import { dialogWidth } from '../../../../constant'

@Component({
    selector: 'app-property-inquiry',
    templateUrl: 'property-inquiry.html'
})
export class PropertyInquiryComponent {

    @Input() headingText = "Couldn't find what you were looking for?"
    @Input() bodyText = 'Give us some details of your requirements and we will get back to you within 48hrs with possible options.'
    @Input() ctaText = 'Contact us'
    @Input() banner = false
    @Input() showCta = true
    @Input() useCustomContentCta = false

    constructor(private _dialog: MatDialog) {}

    openContactForm() {
        this._dialog.open(PropertyInquiryContactFormComponent, {
            width: dialogWidth.md,
            maxWidth: '90vw'
        })
    }
}
